import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ItemListHeader = ({ store, time, long, lat, listId }) => {
  return (
    <Header>
      <Flex>
        <Location>{store}</Location>
        <Date>{time}</Date>
      </Flex>
      <Flex>
        <ButtonWrapper>
          <Link to={`/list/edit/${listId}`}>Edit</Link>
        </ButtonWrapper>
        <Button href={`comgooglemaps://?f=d&daddr=${lat},${long}`}>
          Map it
        </Button>
      </Flex>
    </Header>
  );
};

const Header = styled.div`
  margin-bottom: 20px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Location = styled.h3`
  font-size: 1.8rem;
  margin: 0;
`;

const Date = styled.p`
  color: var(--theme-secondary-color);
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0;
`;

const Button = styled.a`
  background: none;
  border: none;
  font-size: 1rem;
  padding: 5px;
  text-decoration: none;
  display: block;
  color: var(--theme-secondary-color);
`;

const ButtonWrapper = styled.div`
  a {
    font-size: 1rem;
    padding: 5px;
    text-decoration: none;
    display: block;
    color: var(--theme-secondary-color);
    margin-top: 5px;
  }
`;
